// @ts-nocheck
import React from "react";
import Form from "src/components/Forms/Form";
import { FormikHelpers as FormikActions, FormikValues } from "formik";
import { Schema } from "yup";
import { CreateCampaignGroupFormContainer } from "./container";
import { Button } from "src/components/Core/Button";
import { LinkButton } from "src/components/Core/LinkButton";
import styled from "styled-components";
import Loading from "src/shared/Loading";
import { Box } from "src/components/Core/Box";
import {
  GlobalErrorProps,
  GlobalErrors,
} from "src/components/Forms/ErrorMessage";
import {
  GroupTitle,
  Company,
  Brands,
} from "src/components/Modules/Campaign/Fields";

interface CreateCampaignGroupFormProps<Values = FormikValues> {
  globalErrors?: GlobalErrorProps[];
  initialValues: Values;
  isSubmitting: boolean;
  createCampaignGroupSchema: Schema<object>;
  onSubmit: (values: any, formikActions: FormikActions<any>) => void;
  closeCreateCampaignGroupModal: () => void;
  getCompanies: Function;
  getBrands: Function;
}

export const CreateCampaignGroupFormWrapper = styled.div`
  width: 100%;
`;

const CreateCampaignGroupForm: React.FC<CreateCampaignGroupFormProps> = ({
  initialValues,
  isSubmitting,
  createCampaignGroupSchema,
  onSubmit,
  globalErrors,
  closeCreateCampaignGroupModal,
  getCompanies,
  getBrands,
}) => {
  return (
    <CreateCampaignGroupFormWrapper>
      <Loading spinning={isSubmitting}>
        <GlobalErrors errors={globalErrors} />

        <Form
          initialValues={initialValues}
          schema={createCampaignGroupSchema}
          onSubmit={(values, actions) => onSubmit(values, actions)}
        >
          {(formProps: any) => {
            return (
              <>
                <GroupTitle title="Group Title:" name="groupName" />

                <Company getCompanies={getCompanies} />

                <Brands getBrands={getBrands} />

                <Box
                  alignItems="right"
                  textAlign="right"
                  display="inherit"
                  mt={20}
                >
                  <LinkButton
                    onClick={() => closeCreateCampaignGroupModal()}
                    mr={20}
                  >
                    Cancel
                  </LinkButton>

                  <Button
                    htmlType="submit"
                    type="action"
                    loading={isSubmitting}
                    disabled={isSubmitting}
                    buttonSize="middle"
                    data-cy="submit-button"
                  >
                    Submit
                  </Button>
                </Box>
              </>
            );
          }}
        </Form>
      </Loading>
    </CreateCampaignGroupFormWrapper>
  );
};

export { CreateCampaignGroupForm, CreateCampaignGroupFormContainer };
